import React, { useRef } from 'react';
import { Typography, Tooltip, TypographyProps, Box } from '@mui/material';
import { useTextOverflow } from '../../hooks/useTextOverflow';

interface TextWithTooltipProps extends TypographyProps {
  text: string;
  tooltipTitle?: string;
}

/**
 * Component that automatically detects overflow and shows tooltip only when needed
 */
const TextWithTooltip: React.FC<TextWithTooltipProps> = ({
  text,
  tooltipTitle,
  ...typographyProps
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const isOverflowing = useTextOverflow(
    textRef as React.RefObject<HTMLElement>
  );

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Tooltip
        title={tooltipTitle || text}
        placement="top-start"
        disableHoverListener={!isOverflowing}
      >
        <Typography
          ref={textRef}
          noWrap
          {...typographyProps}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            ...(typographyProps.sx || {}),
          }}
        >
          {text}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default TextWithTooltip;
